import './LoaderOverlay.css';
export var loaderOverlay = '_mo8t1w0-2-0-1';
export var progressCircle = '_mo8t1w1-2-0-1';